import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { switchProp, ifProp } from "styled-tools";

const BaseStyle = styled.a.attrs(
  ({
    left,
    right,
    nomargin,
    margin,
    href,
    fontsize,
    marginsmall,
    white,
    color,
    theme,
    width,
    textTransform,
    forceFontSize,
  }) => ({
    marginright: left ? "auto" : 0,
    width: width ? width : "",

    marginleft: right ? "auto" : 0,
    margin: nomargin
      ? 0
      : margin
      ? margin
      : `0.5rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
    href: href ? href : "",
    fontsize: fontsize ? fontsize : "16px",
    marginSmall: marginsmall ? marginsmall : margin ? margin : 0,
    color: color ? color : white ? white : theme.colors.black,
    textTransform: textTransform ? textTransform : undefined,
    forceFontSize: forceFontSize ? forceFontSize : undefined,
  })
)`
  margin: ${({ marginSmall }) => marginSmall};
  width: ${({ width }) => width};
  text-align: ${({ textAlign }) => textAlign};
  ${media.greaterThan(breakpoints.ipad)`
		margin-right: ${({ marginright }) => marginright};
		margin-left: ${({ marginleft }) => marginleft};
		margin: ${({ margin }) => margin};
  	`}

  &:focus,
  	&:hover {
    span {
      border-bottom: ${({ inverted, color, theme }) =>
        inverted ? `2px solid ${theme.colors.none}` : `2px solid ${color}`};
    }
  }

  span {
    border-bottom: ${({ inverted, color, theme }) =>
      inverted ? `2px solid ${color}` : `2px solid ${theme.colors.none}`};
    transition: all 0.2s ease;
    color: ${({ color }) => color};
  }
  ${({ textTransform }) =>
    textTransform &&
    css`
      text-transform: ${({ textTransform }) => textTransform};
      span {
        text-transform: ${({ textTransform }) => textTransform};
      }
    `}

  ${({ forceFontSize }) =>
    forceFontSize &&
    css`
      font-size: ${({ forceFontSize }) => forceFontSize} !important;
      span {
        font-size: ${({ forceFontSize }) => forceFontSize} !important;
      }
    `}
`;

export const PrimaryLinkStyle = styled(BaseStyle)``;

export const HeaderLinkStyle = styled(BaseStyle).attrs(({ size }) => ({
  elementsize: size,
}))`
  display: ${({ inline }) => (inline ? "inline-block" : "block")};
  font-weight: bold;

  ${switchProp("elementsize", {
    h1: css`
      font-size: 36px;
      line-height: 42px;

      ${media.greaterThan(breakpoints.ipad)`
            font-size: 50px;
            line-height: 38px;
        `}
    `,
    h2: css`
      font-size: 24px;
      line-height: 30px;

      ${media.greaterThan(breakpoints.ipad)`
            font-size: 32px;
            line-height: 38px;
        `}
    `,
    h3: css`
      font-size: 20px;
      line-height: 26px;

      ${media.greaterThan(breakpoints.ipad)`
            font-size: 24px;
            line-height: 30px;
        `}
    `,
    h4: css`
      font-size: 18px;
      line-height: 24px;

      ${media.greaterThan(breakpoints.ipad)`
            font-size: 20px;
            line-height: 24px;
        `}
    `,
  })}
`;
